<template>
  <div class="box">
    <!-- <Header></Header> -->
    <div class="detail">
      <h1>{{ data.name }}</h1>

      <div class="box">
        <img :src="data.navigation" class="img" />
      </div>
    </div>
    <div class="product">
      <div class="box1">

        <h1>项目介绍</h1>
        <span>{{ data.intro }} </span>
      </div>

    </div>
  </div>
</template>

<script>
  import Header from "@/components/header.vue";
  import Footer from "@/components/footer.vue";
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        data: {},
      };
    },
    created() {
      let data = JSON.parse(this.$route.query.data);
      this.data = data;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    mounted() {},
    methods: {
      back() {
        this.$router.push("/case");
      },
      Ios() {
        window.location.href = this.data.ios;
      },
      Android() {
        window.location.href = this.data.android;
      },
    },
  };
</script>

<style lang="less">
  .box {
    position: relative;
  }

  .detail {
    padding: 80px 50px 40px 50px;

    // position: absolute;
    h1 {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: #333;
      padding: 40px;
    }

    // height: 600px;
    width: 100%;
    margin: auto;
    background-image: url("../assets/bg_case.png");
    color: #fff;

    .box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .img {
      width: 400px;
      height: 290px;
    }

    h6 {
      font-size: 24px;
      color: #333;
      font-weight: bold;
    }




  }

  .product {
    margin: 80px 0;

    .box1 {
      text-align: center;
      margin-top: 80px;

      h1 {
        font-size: 24px;
        font-weight: bold;
        color: #333;
      }

      p {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }

      span {
        color: #808080;
        font-size: 16px;
      }
    }

    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .box1 {
        width: 48%;

        .img {
          width: 397px;
        }
      }
    }
  }
</style>